import { create } from "zustand";

const initialState = {
  selectedContact: null,
  contactInfo: null,
  totalUnreadNotifications: 0,
  contactsListLoading: true,
};

export const useInboxStore = create((set, get) => ({
  ...initialState,
  actions: {
    setContactsListLoading: (value) => set({ contactsListLoading: value }),
    setSelectedContact: (contact) => set({ selectedContact: contact }),
    getSelectedContact: () => get().selectedContact,
    setContactInfo: (data) => set({ contactInfo: data }),
    setTotalUnreadNotifications: (value) =>
      set({ totalUnreadNotifications: value }),
    reset: () => set({ ...initialState }),
  },
}));
